import React from 'react';

function Map() {
    return (
        <div>
            <div className="map">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117487.09596163566!2d72.33387034335937!3d23.043160299999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9b4c2f39af29%3A0xcdab08998e509a5a!2sLAXMI%20MULTI%20SPECIALITY%20HOSPITAL!5e0!3m2!1sen!2sin!4v1764924523415!5m2!1sen!2sin"
                    width="100%"
                    height="450"
                    style={{ border: "0" }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade">
                </iframe>
            </div>
        </div>
    )
}

export default Map;
